export default {
  "status": {
    "世界遺産": 30,
    "現存": 16,
    "消滅": 41
  },
  "shape": {
    "前方後円墳": 39,
    "帆立貝形墳": 4,
    "円墳": 23,
    "方墳": 21,
    "形状不明": 0
  },
  "length": {
    "200m以上": 11,
    "100m以上200m未満": 14,
    "50m以上100m未満": 11,
    "50m未満": 41,
    "不明": 0
  }
}



// WEBPACK FOOTER //
// ./map/js/ih/data/mozu-furu-artifact_kofun_number.js